<template>
    <div :class="$style.app" key="app" id="quiz-widget-app">
      <transition
        :enter-active-class="$style['fade-enter-active']"
        :leave-active-class="$style['fade-leave-active']"
        :enter-from-class="$style['fade-enter-from']"
        :leave-to-class="$style['fade-leave-to']"
      >
        <MainQuiz :status="status"/>
      </transition>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, onBeforeUnmount, watch, defineAsyncComponent } from 'vue'
import checkHash from '@/core/checkHash'

const { widgetInfo, openInfo } = inject('pageInfo')
const MainQuiz = defineAsyncComponent(() =>
  openInfo?.type === 'chat'
    ? import(/* webpackChunkName: "chat" */ '@/components/chat/layout/ChatWindow.vue')
    : import(/* webpackChunkName: "quiz" */ '@/components/quiz/quizBody/wrapper.vue')
)
const hasHash = ref(false)
function manageHash () {
  hasHash.value = checkHash()
  if (hasHash.value) {
    status.value = true
  }
}
const status = ref(openInfo.type === 'pluggable' || openInfo.type === 'landing' || openInfo.type === 'chat')

onMounted(() => {
  if (openInfo.settings?.isOpenAfterLoad && !sessionStorage.getItem(location.host + 'autoopen')) {
    setTimeout(() => {
      sessionStorage.setItem(location.host + 'autoopen', '1')
      status.value = true
    }, openInfo.settings?.openTimeoutAfterLoad || 5000)
  } else {
    manageHash()
  }
  window.addEventListener('hashchange', manageHash)
})

onBeforeUnmount(() => {
  window.removeEventListener('hashchange', manageHash)
})

watch(
  () => status.value,
  () => {
    if (!status.value && hasHash) {
      history.pushState('', document.title, window.location.pathname + window.location.search)
    }
  }
)
</script>

<style lang="scss" module>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
@include base-style
.app {
  color: black;
  font-size: v-bind('widgetInfo.fontSize');
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
